import Logo from "../../assets/img/logos/logoWhite.png";
import LogoColegio from "../../assets/img/logos/colegio.png";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-primary to-secondary text-white py-8 rounded-lg shadow-md">
      <div className="container mx-auto px-4">
        <div className="md:flex md:justify-between md:items-center">
          <div className="mb-4 md:mb-0 flex justify-center">
            <img src={Logo} alt="Logo Colegio" className="h-20" />
          </div>
          <div className="flex flex-col items-center justify-center">
            <div className="mb-4 md:mb-0 flex justify-center">
              <img src={LogoColegio} alt="Logo Colegio" className=" h-16" />
            </div>
            <p className="text-sm mt-2">
              Fernando Zapiola Tº III - Fº 704 - Nº 1363
            </p>
          </div>
          <div>
            <nav className="flex flex-col items-center md:items-end mt-4">
              <a href="/" className="hover:text-[#4EB8A3] mb-1">
                Home
              </a>
              <a href="/tipo/Venta" className="hover:text-[#4EB8A3] mb-1">
                Ventas
              </a>
              <a href="/tipo/Alquiler" className="hover:text-[#4EB8A3]">
                Alquileres
              </a>
            </nav>
          </div>
        </div>
        <hr className="my-6 border-white" />
        <div className="text-center text-sm">
          &copy; {new Date().getFullYear()} Inmobiliaria Zapiola. Todos los
          derechos reservados.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
